import { useAtom } from "jotai";
import { merchantAtom } from "../atoms";

const useMerchantHook = () => {
  const state = useAtom(merchantAtom);
  return state;
};

export default useMerchantHook;
